import { render, staticRenderFns } from "./tagData.vue?vue&type=template&id=65fd2434&scoped=true&"
import script from "./tagData.vue?vue&type=script&lang=js&"
export * from "./tagData.vue?vue&type=script&lang=js&"
import style0 from "./tagData.vue?vue&type=style&index=0&id=65fd2434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd2434",
  null
  
)

export default component.exports